export const ALGOLIA_ENDPOINT_NAME = 'Product comparison algolia'
export const AUTOCOMPLETE_MINIMUM_LENGTH = 2
export const AUTOCOMPLETE_DEBOUNCE_DELAY = 100
